import * as Yup from 'yup';
import i18n from '@i18n/i18n';

export const applyYupLocale = (): void => {
  Yup.setLocale({
    mixed: {
      required: () => i18n.t('validation.required'),
    },
    string: {
      email: () => i18n.t('validation.email'),
    },
  });
};

applyYupLocale();

i18n.on('languageChanged', applyYupLocale);
